import { render, staticRenderFns } from "./ViewMachineTypeResources.vue?vue&type=template&id=09ef2e86&scoped=true&"
import script from "./ViewMachineTypeResources.vue?vue&type=script&lang=js&"
export * from "./ViewMachineTypeResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ef2e86",
  null
  
)

export default component.exports